import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'リセット　パスワード',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: false,
};
